import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ExternalLink, Mic } from "lucide-react";
import api from "../../lib/api";

// "Podcasts talking about this" on a title's detail page; hidden when none.
export default function TitlePodcasts({ titleId, flatHead }) {
  const [eps, setEps] = useState([]);
  useEffect(() => {
    setEps([]);
    api.get(`/catalog/title/${encodeURIComponent(titleId)}/podcasts`).then(({ data }) => setEps(data.episodes || [])).catch(() => {});
  }, [titleId]);
  if (!eps.length) return null;
  return (
    <div className="mt-10" data-testid="title-podcasts">
      <h2 className={`font-head text-2xl text-[var(--text-primary)] ${flatHead ? "font-bold" : "tracking-wide"}`}>Podcasts talking about this</h2>
      <ul className="mt-4 grid gap-3 sm:grid-cols-2">
        {eps.map((e) => (
          <li key={e.id} className="flex items-center gap-3 rounded-[var(--card-radius)] border border-[var(--border-subtle)] bg-[var(--bg-card)] p-3" data-testid={`title-podcast-${e.id}`}>
            <Link to={`/podcast/${e.show.slug}`} className="flex-none" data-testid={`title-podcast-show-${e.id}`}>
              {e.show.cover_art ? <img src={e.show.cover_art} alt={e.show.name} className="h-14 w-14 rounded object-cover" /> : <span className="flex h-14 w-14 items-center justify-center rounded bg-[var(--bg-base)] text-[var(--text-muted)]"><Mic size={20} /></span>}
            </Link>
            <div className="min-w-0">
              <a href={e.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-start gap-1.5 text-sm font-semibold text-[var(--text-primary)] hover:text-[var(--accent-hover)]" data-testid={`title-podcast-link-${e.id}`}>
                <ExternalLink size={14} className="mt-0.5 flex-none" /><span className="break-words">{e.title}</span>
              </a>
              <Link to={`/podcast/${e.show.slug}`} className="mt-0.5 block truncate text-xs text-[var(--text-secondary)] hover:text-[var(--accent-hover)]">{e.show.name}</Link>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
